// extracted by mini-css-extract-plugin
export default {"button":"DeleteButton_button__PBbO3","icon":"DeleteButton_icon__iF+ec"};